import { render } from "./SingleSpinLoading.vue?vue&type=template&id=48124222"
import script from "./SingleSpinLoading.vue?vue&type=script&lang=js"
export * from "./SingleSpinLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__